import { Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { PoTableColumn } from '@po-ui/ng-components';
import { CONSTANTS } from 'src/app/constants';
import { ApiService } from 'src/app/shared/service/api.service';

@Component({
  selector: 'app-financial-open-value',
  templateUrl: './financial-open-value.component.html',
  styleUrls: ['./financial-open-value.component.css']
})
export class FinancialOpenValueComponent implements OnInit {
  _filterAccomplish: any = {};
  @Input() set filterAccomplish(value: any) {
    this._filterAccomplish = value;
    this.filterItem(this._filterAccomplish);
  }

  @Output() errorEmitter = new EventEmitter();

  dataSource: any = {
    data: []
  }

  itemList: any = {};
  loading: boolean = true;
  errorApi: boolean = false;
  message : string = "";
  items: Array<any> = [];
  columns: Array<PoTableColumn> = this.getColumns();

  constructor(private api: ApiService) { }

  ngOnInit(): void {
    this.getColumns();
  }

  filterItem(item: any) {
    this.errorApi = false;
    this.loading = true;
    this.openValueInformation(item);
  }

  openValueInformation(item: any) {
    this.api.postOpenAmountByDocument(item.branch).subscribe(data => {
      try {
        this.dataSource.data = [];
        if(data.dataRow.length != 0) {
          for (let i = 0; i < data.dataRow.length; i++) {
            data.dataRow[i].value_title = parseFloat(data.dataRow[i].value_title).toLocaleString('pt-br', {minimumFractionDigits: 2});
          }
          this.items = [];
          data.dataRow.forEach((item: any) => {
            this.items.push({
              value_title: 'R$ ' + item.value_title,
              type_document: item.type_document
            });
          });
          this.loading = false;
        } else {
          this.loading = false;
          this.errorApi = true;
          this.message = CONSTANTS.MESSAGES.DATA_NULL_OPEN_AMOUNT_DOCUMENT;
          this.formatErrorMensagem(CONSTANTS.MESSAGES.DATA_NULL_OPEN_AMOUNT_DOCUMENT);
        }
      } catch (error : unknown) {
        this.loading = false;
        if(error instanceof Error)
          this.message = error.message;
          this.formatErrorMensagem(this.message);
      }
    }, error => {
      this.loading = false;
      this.errorApi = true;
      this.message = CONSTANTS.MESSAGES.DATA_ERRO_OPEN_AMOUNT_DOCUMENT;
      this.formatErrorMensagem(error.message);
    })
  }

  formatErrorMensagem(item: any) {
    let dataError = new Date();
    let errorMensagem = "Arquivo: financial-open-value \r\n" + "Data: " + dataError + "\r\n" + "Mensagem: " + item + "\r\n" + "===============================================" + "\r\n";
    this.errorEmitter.emit(errorMensagem);
  }

  getColumns(): PoTableColumn[] {
    return [
      { property: 'type_document', label: 'Forma de pagamento', type: 'string' },
      { property: 'value_title', label: 'Valor R$', type: 'string' }
    ];
  }
}
